const Error = ({err}) => {
  return err && <div className="mt-5 w-full text-center text-xl text-red-600">{err}</div>
}

export default Error